const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export async function api(path, { token, body, ...options } = {}) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  const timeout = setTimeout(abort, 15000);
  if (options.signal?.aborted) abort();
  options.signal?.addEventListener("abort", abort, { once: true });
  try {
    const response = await fetch(`${base}/api${path}`, {
      ...options,
      signal: controller.signal,
      headers: {
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      ...(body !== undefined ? { method: "POST", body: JSON.stringify(body) } : {}),
    });
    if (!response.headers.get("content-type")?.includes("application/json")) {
      throw new Error("The service returned an unexpected response. Please try again later.");
    }
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data?.error || "The request failed. Please try again.");
      error.status = response.status;
      throw error;
    }
    return data;
  } catch (error) {
    if (error.name === "AbortError" && !options.signal?.aborted) throw new Error("The request timed out. Please try again.");
    throw error;
  } finally {
    clearTimeout(timeout);
    options.signal?.removeEventListener("abort", abort);
  }
}

export async function submitEnquiry(path, body) {
  const data = await api(path, { body });
  if (typeof data?.id !== "string" || !data.created_at) {
    throw new Error("Your request could not be confirmed. Please contact me by email.");
  }
  return data;
}
